import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const root = css`
  display: inline-block;
  border: 1px solid;
  border-radius: 4px;
  padding: var(${themeVariables.spacing.xxs}) var(${themeVariables.spacing.xs});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-weight: var(${themeVariables.typography.body.fontWeight});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
  background-color: transparent;
`;

export const offer = css`
  border-color: var(${themeVariables.colors.stroke.positive});
  color: var(${themeVariables.colors.content.positive});
`;

export const sale = css`
  border-color: var(${themeVariables.colors.stroke.negative});
  color: var(${themeVariables.colors.content.negative});
`;
